import PageSuccess from "./PageSuccess";

export default PageSuccess;
